module.exports = __webpack_public_path__ + "img/welcome-4.7aa867ea.png";